module.exports = __webpack_public_path__ + "img/tondo_logo_purple.05b24835.svg";